import store from '../../../store';
export default function checkIfCanDeleteSuggestion() {
  let exists = false;
  let scopes = store.getters.userScopes;
  exists = scopes.includes('suggestions_delete');
  return exists;
}
